/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubJoinRouteImport } from './routes/sub-join'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InviteRouteImport } from './routes/invite'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as WizardRouteImport } from './routes/_wizard'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedToolboxRouteImport } from './routes/_authenticated/toolbox'
import { Route as AuthenticatedTeamCertificationsRouteImport } from './routes/_authenticated/team-certifications'
import { Route as AuthenticatedSupervisorRouteImport } from './routes/_authenticated/supervisor'
import { Route as AuthenticatedSubcontractorsRouteImport } from './routes/_authenticated/subcontractors'
import { Route as AuthenticatedSafetyTasksRouteImport } from './routes/_authenticated/safety-tasks'
import { Route as AuthenticatedReviewRouteImport } from './routes/_authenticated/review'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPermitsRouteImport } from './routes/_authenticated/permits'
import { Route as AuthenticatedMySignaturesRouteImport } from './routes/_authenticated/my-signatures'
import { Route as AuthenticatedMyNotesRouteImport } from './routes/_authenticated/my-notes'
import { Route as AuthenticatedMyFlhasRouteImport } from './routes/_authenticated/my-flhas'
import { Route as AuthenticatedMyCertificationsRouteImport } from './routes/_authenticated/my-certifications'
import { Route as AuthenticatedMyAssignmentsRouteImport } from './routes/_authenticated/my-assignments'
import { Route as AuthenticatedInspectionsRouteImport } from './routes/_authenticated/inspections'
import { Route as AuthenticatedIncidentsRouteImport } from './routes/_authenticated/incidents'
import { Route as AuthenticatedHazardsRouteImport } from './routes/_authenticated/hazards'
import { Route as AuthenticatedFlhasRouteImport } from './routes/_authenticated/flhas'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedCorrectiveActionsRouteImport } from './routes/_authenticated/corrective-actions'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets'
import { Route as AuthenticatedApprovalsRouteImport } from './routes/_authenticated/approvals'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedToolboxIndexRouteImport } from './routes/_authenticated/toolbox/index'
import { Route as AuthenticatedSubcontractorsIndexRouteImport } from './routes/_authenticated/subcontractors/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedPermitsIndexRouteImport } from './routes/_authenticated/permits/index'
import { Route as AuthenticatedAssetsIndexRouteImport } from './routes/_authenticated/assets/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as WizardFlhaNewV2RouteImport } from './routes/_wizard/flha/new-v2'
import { Route as WizardFlhaNewRouteImport } from './routes/_wizard/flha/new'
import { Route as AuthenticatedToolboxNewRouteImport } from './routes/_authenticated/toolbox/new'
import { Route as AuthenticatedToolboxLibraryRouteImport } from './routes/_authenticated/toolbox/library'
import { Route as AuthenticatedToolboxAssignmentsRouteImport } from './routes/_authenticated/toolbox/assignments'
import { Route as AuthenticatedToolboxAccessRouteImport } from './routes/_authenticated/toolbox/access'
import { Route as AuthenticatedToolboxMeetingIdRouteImport } from './routes/_authenticated/toolbox/$meetingId'
import { Route as AuthenticatedReportsSubsRouteImport } from './routes/_authenticated/reports/subs'
import { Route as AuthenticatedReportsPermitsRouteImport } from './routes/_authenticated/reports/permits'
import { Route as AuthenticatedReportsHighRiskRouteImport } from './routes/_authenticated/reports/high-risk'
import { Route as AuthenticatedReportsHeatmapRouteImport } from './routes/_authenticated/reports/heatmap'
import { Route as AuthenticatedReportsHazardsRouteImport } from './routes/_authenticated/reports/hazards'
import { Route as AuthenticatedReportsExportRouteImport } from './routes/_authenticated/reports/export'
import { Route as AuthenticatedProjectsProjectIdRouteImport } from './routes/_authenticated/projects/$projectId'
import { Route as AuthenticatedPermitsNewRouteImport } from './routes/_authenticated/permits/new'
import { Route as AuthenticatedPermitsPermitIdRouteImport } from './routes/_authenticated/permits/$permitId'
import { Route as AuthenticatedInspectionsNewRouteImport } from './routes/_authenticated/inspections/new'
import { Route as AuthenticatedInspectionsInspectionIdRouteImport } from './routes/_authenticated/inspections/$inspectionId'
import { Route as AuthenticatedIncidentsReportRouteImport } from './routes/_authenticated/incidents/report'
import { Route as AuthenticatedIncidentsIncidentIdRouteImport } from './routes/_authenticated/incidents/$incidentId'
import { Route as AuthenticatedHazardsNewRouteImport } from './routes/_authenticated/hazards/new'
import { Route as AuthenticatedFlhaFlhaIdRouteImport } from './routes/_authenticated/flha/$flhaId'
import { Route as AuthenticatedCorrectiveActionsActionIdRouteImport } from './routes/_authenticated/corrective-actions/$actionId'
import { Route as AuthenticatedAssetsScanRouteImport } from './routes/_authenticated/assets/scan'
import { Route as AuthenticatedAssetsAssetIdRouteImport } from './routes/_authenticated/assets/$assetId'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedAdminTemplatesRouteImport } from './routes/_authenticated/admin/templates'
import { Route as AuthenticatedAdminSigningReportsRouteImport } from './routes/_authenticated/admin/signing-reports'
import { Route as AuthenticatedAdminRecipientsRouteImport } from './routes/_authenticated/admin/recipients'
import { Route as AuthenticatedAdminPermitsRouteImport } from './routes/_authenticated/admin/permits'
import { Route as AuthenticatedAdminNotesRouteImport } from './routes/_authenticated/admin/notes'
import { Route as AuthenticatedAdminMappingsRouteImport } from './routes/_authenticated/admin/mappings'
import { Route as AuthenticatedAdminLayoutRouteImport } from './routes/_authenticated/admin/layout'
import { Route as AuthenticatedAdminJobTitlesRouteImport } from './routes/_authenticated/admin/job-titles'
import { Route as AuthenticatedAdminInvitationsRouteImport } from './routes/_authenticated/admin/invitations'
import { Route as AuthenticatedAdminInspectionsRouteImport } from './routes/_authenticated/admin/inspections'
import { Route as AuthenticatedAdminExportRouteImport } from './routes/_authenticated/admin/export'
import { Route as AuthenticatedAdminDocumentsRouteImport } from './routes/_authenticated/admin/documents'
import { Route as AuthenticatedAdminDivisionsRouteImport } from './routes/_authenticated/admin/divisions'
import { Route as AuthenticatedAdminCorrectiveActionsRouteImport } from './routes/_authenticated/admin/corrective-actions'
import { Route as AuthenticatedAdminCertificationsRouteImport } from './routes/_authenticated/admin/certifications'
import { Route as AuthenticatedAdminCatalogsRouteImport } from './routes/_authenticated/admin/catalogs'
import { Route as AuthenticatedAdminBackupRouteImport } from './routes/_authenticated/admin/backup'
import { Route as AuthenticatedAdminAuditLogRouteImport } from './routes/_authenticated/admin/audit-log'
import { Route as AuthenticatedAdminAssignmentsRouteImport } from './routes/_authenticated/admin/assignments'
import { Route as AuthenticatedAdminAssetsRouteImport } from './routes/_authenticated/admin/assets'
import { Route as AuthenticatedAdminAppUpdateRouteImport } from './routes/_authenticated/admin/app-update'
import { Route as AuthenticatedInspectionsInspectionIdSwipeRouteImport } from './routes/_authenticated/inspections/$inspectionId.swipe'
import { Route as AuthenticatedAssetsAssetIdCheckoutRouteImport } from './routes/_authenticated/assets/$assetId.checkout'

const SubJoinRoute = SubJoinRouteImport.update({
  id: '/sub-join',
  path: '/sub-join',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteRoute = InviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const WizardRoute = WizardRouteImport.update({
  id: '/_wizard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedToolboxRoute = AuthenticatedToolboxRouteImport.update({
  id: '/toolbox',
  path: '/toolbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamCertificationsRoute =
  AuthenticatedTeamCertificationsRouteImport.update({
    id: '/team-certifications',
    path: '/team-certifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupervisorRoute = AuthenticatedSupervisorRouteImport.update({
  id: '/supervisor',
  path: '/supervisor',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSubcontractorsRoute =
  AuthenticatedSubcontractorsRouteImport.update({
    id: '/subcontractors',
    path: '/subcontractors',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSafetyTasksRoute =
  AuthenticatedSafetyTasksRouteImport.update({
    id: '/safety-tasks',
    path: '/safety-tasks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReviewRoute = AuthenticatedReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPermitsRoute = AuthenticatedPermitsRouteImport.update({
  id: '/permits',
  path: '/permits',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMySignaturesRoute =
  AuthenticatedMySignaturesRouteImport.update({
    id: '/my-signatures',
    path: '/my-signatures',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyNotesRoute = AuthenticatedMyNotesRouteImport.update({
  id: '/my-notes',
  path: '/my-notes',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyFlhasRoute = AuthenticatedMyFlhasRouteImport.update({
  id: '/my-flhas',
  path: '/my-flhas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMyCertificationsRoute =
  AuthenticatedMyCertificationsRouteImport.update({
    id: '/my-certifications',
    path: '/my-certifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyAssignmentsRoute =
  AuthenticatedMyAssignmentsRouteImport.update({
    id: '/my-assignments',
    path: '/my-assignments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInspectionsRoute =
  AuthenticatedInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIncidentsRoute = AuthenticatedIncidentsRouteImport.update({
  id: '/incidents',
  path: '/incidents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHazardsRoute = AuthenticatedHazardsRouteImport.update({
  id: '/hazards',
  path: '/hazards',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedFlhasRoute = AuthenticatedFlhasRouteImport.update({
  id: '/flhas',
  path: '/flhas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCorrectiveActionsRoute =
  AuthenticatedCorrectiveActionsRouteImport.update({
    id: '/corrective-actions',
    path: '/corrective-actions',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedApprovalsRoute = AuthenticatedApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedToolboxIndexRoute =
  AuthenticatedToolboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedToolboxRoute,
  } as any)
const AuthenticatedSubcontractorsIndexRoute =
  AuthenticatedSubcontractorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSubcontractorsRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsIndexRoute =
  AuthenticatedPermitsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPermitsRoute,
  } as any)
const AuthenticatedAssetsIndexRoute =
  AuthenticatedAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const WizardFlhaNewV2Route = WizardFlhaNewV2RouteImport.update({
  id: '/flha/new-v2',
  path: '/flha/new-v2',
  getParentRoute: () => WizardRoute,
} as any)
const WizardFlhaNewRoute = WizardFlhaNewRouteImport.update({
  id: '/flha/new',
  path: '/flha/new',
  getParentRoute: () => WizardRoute,
} as any)
const AuthenticatedToolboxNewRoute = AuthenticatedToolboxNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedToolboxRoute,
} as any)
const AuthenticatedToolboxLibraryRoute =
  AuthenticatedToolboxLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => AuthenticatedToolboxRoute,
  } as any)
const AuthenticatedToolboxAssignmentsRoute =
  AuthenticatedToolboxAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => AuthenticatedToolboxRoute,
  } as any)
const AuthenticatedToolboxAccessRoute =
  AuthenticatedToolboxAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedToolboxRoute,
  } as any)
const AuthenticatedToolboxMeetingIdRoute =
  AuthenticatedToolboxMeetingIdRouteImport.update({
    id: '/$meetingId',
    path: '/$meetingId',
    getParentRoute: () => AuthenticatedToolboxRoute,
  } as any)
const AuthenticatedReportsSubsRoute =
  AuthenticatedReportsSubsRouteImport.update({
    id: '/subs',
    path: '/subs',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsPermitsRoute =
  AuthenticatedReportsPermitsRouteImport.update({
    id: '/permits',
    path: '/permits',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsHighRiskRoute =
  AuthenticatedReportsHighRiskRouteImport.update({
    id: '/high-risk',
    path: '/high-risk',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsHeatmapRoute =
  AuthenticatedReportsHeatmapRouteImport.update({
    id: '/heatmap',
    path: '/heatmap',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsHazardsRoute =
  AuthenticatedReportsHazardsRouteImport.update({
    id: '/hazards',
    path: '/hazards',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsExportRoute =
  AuthenticatedReportsExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedProjectsProjectIdRoute =
  AuthenticatedProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPermitsNewRoute = AuthenticatedPermitsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedPermitsRoute,
} as any)
const AuthenticatedPermitsPermitIdRoute =
  AuthenticatedPermitsPermitIdRouteImport.update({
    id: '/$permitId',
    path: '/$permitId',
    getParentRoute: () => AuthenticatedPermitsRoute,
  } as any)
const AuthenticatedInspectionsNewRoute =
  AuthenticatedInspectionsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedInspectionsRoute,
  } as any)
const AuthenticatedInspectionsInspectionIdRoute =
  AuthenticatedInspectionsInspectionIdRouteImport.update({
    id: '/$inspectionId',
    path: '/$inspectionId',
    getParentRoute: () => AuthenticatedInspectionsRoute,
  } as any)
const AuthenticatedIncidentsReportRoute =
  AuthenticatedIncidentsReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AuthenticatedIncidentsRoute,
  } as any)
const AuthenticatedIncidentsIncidentIdRoute =
  AuthenticatedIncidentsIncidentIdRouteImport.update({
    id: '/$incidentId',
    path: '/$incidentId',
    getParentRoute: () => AuthenticatedIncidentsRoute,
  } as any)
const AuthenticatedHazardsNewRoute = AuthenticatedHazardsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthenticatedHazardsRoute,
} as any)
const AuthenticatedFlhaFlhaIdRoute = AuthenticatedFlhaFlhaIdRouteImport.update({
  id: '/flha/$flhaId',
  path: '/flha/$flhaId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCorrectiveActionsActionIdRoute =
  AuthenticatedCorrectiveActionsActionIdRouteImport.update({
    id: '/$actionId',
    path: '/$actionId',
    getParentRoute: () => AuthenticatedCorrectiveActionsRoute,
  } as any)
const AuthenticatedAssetsScanRoute = AuthenticatedAssetsScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => AuthenticatedAssetsRoute,
} as any)
const AuthenticatedAssetsAssetIdRoute =
  AuthenticatedAssetsAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AuthenticatedAssetsRoute,
  } as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminTemplatesRoute =
  AuthenticatedAdminTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSigningReportsRoute =
  AuthenticatedAdminSigningReportsRouteImport.update({
    id: '/signing-reports',
    path: '/signing-reports',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRecipientsRoute =
  AuthenticatedAdminRecipientsRouteImport.update({
    id: '/recipients',
    path: '/recipients',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPermitsRoute =
  AuthenticatedAdminPermitsRouteImport.update({
    id: '/permits',
    path: '/permits',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminNotesRoute = AuthenticatedAdminNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAdminMappingsRoute =
  AuthenticatedAdminMappingsRouteImport.update({
    id: '/mappings',
    path: '/mappings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminLayoutRoute =
  AuthenticatedAdminLayoutRouteImport.update({
    id: '/layout',
    path: '/layout',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminJobTitlesRoute =
  AuthenticatedAdminJobTitlesRouteImport.update({
    id: '/job-titles',
    path: '/job-titles',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminInvitationsRoute =
  AuthenticatedAdminInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminInspectionsRoute =
  AuthenticatedAdminInspectionsRouteImport.update({
    id: '/inspections',
    path: '/inspections',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminExportRoute =
  AuthenticatedAdminExportRouteImport.update({
    id: '/export',
    path: '/export',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDocumentsRoute =
  AuthenticatedAdminDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminDivisionsRoute =
  AuthenticatedAdminDivisionsRouteImport.update({
    id: '/divisions',
    path: '/divisions',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCorrectiveActionsRoute =
  AuthenticatedAdminCorrectiveActionsRouteImport.update({
    id: '/corrective-actions',
    path: '/corrective-actions',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCertificationsRoute =
  AuthenticatedAdminCertificationsRouteImport.update({
    id: '/certifications',
    path: '/certifications',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminCatalogsRoute =
  AuthenticatedAdminCatalogsRouteImport.update({
    id: '/catalogs',
    path: '/catalogs',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminBackupRoute =
  AuthenticatedAdminBackupRouteImport.update({
    id: '/backup',
    path: '/backup',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditLogRoute =
  AuthenticatedAdminAuditLogRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAssignmentsRoute =
  AuthenticatedAdminAssignmentsRouteImport.update({
    id: '/assignments',
    path: '/assignments',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAssetsRoute =
  AuthenticatedAdminAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAppUpdateRoute =
  AuthenticatedAdminAppUpdateRouteImport.update({
    id: '/app-update',
    path: '/app-update',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedInspectionsInspectionIdSwipeRoute =
  AuthenticatedInspectionsInspectionIdSwipeRouteImport.update({
    id: '/swipe',
    path: '/swipe',
    getParentRoute: () => AuthenticatedInspectionsInspectionIdRoute,
  } as any)
const AuthenticatedAssetsAssetIdCheckoutRoute =
  AuthenticatedAssetsAssetIdCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AuthenticatedAssetsAssetIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/sub-join': typeof SubJoinRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/corrective-actions': typeof AuthenticatedCorrectiveActionsRouteWithChildren
  '/documents': typeof AuthenticatedDocumentsRoute
  '/flhas': typeof AuthenticatedFlhasRoute
  '/hazards': typeof AuthenticatedHazardsRouteWithChildren
  '/incidents': typeof AuthenticatedIncidentsRouteWithChildren
  '/inspections': typeof AuthenticatedInspectionsRouteWithChildren
  '/my-assignments': typeof AuthenticatedMyAssignmentsRoute
  '/my-certifications': typeof AuthenticatedMyCertificationsRoute
  '/my-flhas': typeof AuthenticatedMyFlhasRoute
  '/my-notes': typeof AuthenticatedMyNotesRoute
  '/my-signatures': typeof AuthenticatedMySignaturesRoute
  '/permits': typeof AuthenticatedPermitsRouteWithChildren
  '/profile': typeof AuthenticatedProfileRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/review': typeof AuthenticatedReviewRoute
  '/safety-tasks': typeof AuthenticatedSafetyTasksRoute
  '/subcontractors': typeof AuthenticatedSubcontractorsRouteWithChildren
  '/supervisor': typeof AuthenticatedSupervisorRoute
  '/team-certifications': typeof AuthenticatedTeamCertificationsRoute
  '/toolbox': typeof AuthenticatedToolboxRouteWithChildren
  '/admin/app-update': typeof AuthenticatedAdminAppUpdateRoute
  '/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/admin/assignments': typeof AuthenticatedAdminAssignmentsRoute
  '/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/admin/backup': typeof AuthenticatedAdminBackupRoute
  '/admin/catalogs': typeof AuthenticatedAdminCatalogsRoute
  '/admin/certifications': typeof AuthenticatedAdminCertificationsRoute
  '/admin/corrective-actions': typeof AuthenticatedAdminCorrectiveActionsRoute
  '/admin/divisions': typeof AuthenticatedAdminDivisionsRoute
  '/admin/documents': typeof AuthenticatedAdminDocumentsRoute
  '/admin/export': typeof AuthenticatedAdminExportRoute
  '/admin/inspections': typeof AuthenticatedAdminInspectionsRoute
  '/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/admin/job-titles': typeof AuthenticatedAdminJobTitlesRoute
  '/admin/layout': typeof AuthenticatedAdminLayoutRoute
  '/admin/mappings': typeof AuthenticatedAdminMappingsRoute
  '/admin/notes': typeof AuthenticatedAdminNotesRoute
  '/admin/permits': typeof AuthenticatedAdminPermitsRoute
  '/admin/recipients': typeof AuthenticatedAdminRecipientsRoute
  '/admin/signing-reports': typeof AuthenticatedAdminSigningReportsRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRouteWithChildren
  '/assets/scan': typeof AuthenticatedAssetsScanRoute
  '/corrective-actions/$actionId': typeof AuthenticatedCorrectiveActionsActionIdRoute
  '/flha/$flhaId': typeof AuthenticatedFlhaFlhaIdRoute
  '/hazards/new': typeof AuthenticatedHazardsNewRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/incidents/report': typeof AuthenticatedIncidentsReportRoute
  '/inspections/$inspectionId': typeof AuthenticatedInspectionsInspectionIdRouteWithChildren
  '/inspections/new': typeof AuthenticatedInspectionsNewRoute
  '/permits/$permitId': typeof AuthenticatedPermitsPermitIdRoute
  '/permits/new': typeof AuthenticatedPermitsNewRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/reports/export': typeof AuthenticatedReportsExportRoute
  '/reports/hazards': typeof AuthenticatedReportsHazardsRoute
  '/reports/heatmap': typeof AuthenticatedReportsHeatmapRoute
  '/reports/high-risk': typeof AuthenticatedReportsHighRiskRoute
  '/reports/permits': typeof AuthenticatedReportsPermitsRoute
  '/reports/subs': typeof AuthenticatedReportsSubsRoute
  '/toolbox/$meetingId': typeof AuthenticatedToolboxMeetingIdRoute
  '/toolbox/access': typeof AuthenticatedToolboxAccessRoute
  '/toolbox/assignments': typeof AuthenticatedToolboxAssignmentsRoute
  '/toolbox/library': typeof AuthenticatedToolboxLibraryRoute
  '/toolbox/new': typeof AuthenticatedToolboxNewRoute
  '/flha/new': typeof WizardFlhaNewRoute
  '/flha/new-v2': typeof WizardFlhaNewV2Route
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/assets/': typeof AuthenticatedAssetsIndexRoute
  '/permits/': typeof AuthenticatedPermitsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/subcontractors/': typeof AuthenticatedSubcontractorsIndexRoute
  '/toolbox/': typeof AuthenticatedToolboxIndexRoute
  '/assets/$assetId/checkout': typeof AuthenticatedAssetsAssetIdCheckoutRoute
  '/inspections/$inspectionId/swipe': typeof AuthenticatedInspectionsInspectionIdSwipeRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/sub-join': typeof SubJoinRoute
  '/approvals': typeof AuthenticatedApprovalsRoute
  '/corrective-actions': typeof AuthenticatedCorrectiveActionsRouteWithChildren
  '/documents': typeof AuthenticatedDocumentsRoute
  '/flhas': typeof AuthenticatedFlhasRoute
  '/hazards': typeof AuthenticatedHazardsRouteWithChildren
  '/incidents': typeof AuthenticatedIncidentsRouteWithChildren
  '/inspections': typeof AuthenticatedInspectionsRouteWithChildren
  '/my-assignments': typeof AuthenticatedMyAssignmentsRoute
  '/my-certifications': typeof AuthenticatedMyCertificationsRoute
  '/my-flhas': typeof AuthenticatedMyFlhasRoute
  '/my-notes': typeof AuthenticatedMyNotesRoute
  '/my-signatures': typeof AuthenticatedMySignaturesRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/review': typeof AuthenticatedReviewRoute
  '/safety-tasks': typeof AuthenticatedSafetyTasksRoute
  '/supervisor': typeof AuthenticatedSupervisorRoute
  '/team-certifications': typeof AuthenticatedTeamCertificationsRoute
  '/admin/app-update': typeof AuthenticatedAdminAppUpdateRoute
  '/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/admin/assignments': typeof AuthenticatedAdminAssignmentsRoute
  '/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/admin/backup': typeof AuthenticatedAdminBackupRoute
  '/admin/catalogs': typeof AuthenticatedAdminCatalogsRoute
  '/admin/certifications': typeof AuthenticatedAdminCertificationsRoute
  '/admin/corrective-actions': typeof AuthenticatedAdminCorrectiveActionsRoute
  '/admin/divisions': typeof AuthenticatedAdminDivisionsRoute
  '/admin/documents': typeof AuthenticatedAdminDocumentsRoute
  '/admin/export': typeof AuthenticatedAdminExportRoute
  '/admin/inspections': typeof AuthenticatedAdminInspectionsRoute
  '/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/admin/job-titles': typeof AuthenticatedAdminJobTitlesRoute
  '/admin/layout': typeof AuthenticatedAdminLayoutRoute
  '/admin/mappings': typeof AuthenticatedAdminMappingsRoute
  '/admin/notes': typeof AuthenticatedAdminNotesRoute
  '/admin/permits': typeof AuthenticatedAdminPermitsRoute
  '/admin/recipients': typeof AuthenticatedAdminRecipientsRoute
  '/admin/signing-reports': typeof AuthenticatedAdminSigningReportsRoute
  '/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/assets/$assetId': typeof AuthenticatedAssetsAssetIdRouteWithChildren
  '/assets/scan': typeof AuthenticatedAssetsScanRoute
  '/corrective-actions/$actionId': typeof AuthenticatedCorrectiveActionsActionIdRoute
  '/flha/$flhaId': typeof AuthenticatedFlhaFlhaIdRoute
  '/hazards/new': typeof AuthenticatedHazardsNewRoute
  '/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/incidents/report': typeof AuthenticatedIncidentsReportRoute
  '/inspections/$inspectionId': typeof AuthenticatedInspectionsInspectionIdRouteWithChildren
  '/inspections/new': typeof AuthenticatedInspectionsNewRoute
  '/permits/$permitId': typeof AuthenticatedPermitsPermitIdRoute
  '/permits/new': typeof AuthenticatedPermitsNewRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/reports/export': typeof AuthenticatedReportsExportRoute
  '/reports/hazards': typeof AuthenticatedReportsHazardsRoute
  '/reports/heatmap': typeof AuthenticatedReportsHeatmapRoute
  '/reports/high-risk': typeof AuthenticatedReportsHighRiskRoute
  '/reports/permits': typeof AuthenticatedReportsPermitsRoute
  '/reports/subs': typeof AuthenticatedReportsSubsRoute
  '/toolbox/$meetingId': typeof AuthenticatedToolboxMeetingIdRoute
  '/toolbox/access': typeof AuthenticatedToolboxAccessRoute
  '/toolbox/assignments': typeof AuthenticatedToolboxAssignmentsRoute
  '/toolbox/library': typeof AuthenticatedToolboxLibraryRoute
  '/toolbox/new': typeof AuthenticatedToolboxNewRoute
  '/flha/new': typeof WizardFlhaNewRoute
  '/flha/new-v2': typeof WizardFlhaNewV2Route
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/assets': typeof AuthenticatedAssetsIndexRoute
  '/permits': typeof AuthenticatedPermitsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/subcontractors': typeof AuthenticatedSubcontractorsIndexRoute
  '/toolbox': typeof AuthenticatedToolboxIndexRoute
  '/assets/$assetId/checkout': typeof AuthenticatedAssetsAssetIdCheckoutRoute
  '/inspections/$inspectionId/swipe': typeof AuthenticatedInspectionsInspectionIdSwipeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_wizard': typeof WizardRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/invite': typeof InviteRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/sub-join': typeof SubJoinRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/approvals': typeof AuthenticatedApprovalsRoute
  '/_authenticated/assets': typeof AuthenticatedAssetsRouteWithChildren
  '/_authenticated/corrective-actions': typeof AuthenticatedCorrectiveActionsRouteWithChildren
  '/_authenticated/documents': typeof AuthenticatedDocumentsRoute
  '/_authenticated/flhas': typeof AuthenticatedFlhasRoute
  '/_authenticated/hazards': typeof AuthenticatedHazardsRouteWithChildren
  '/_authenticated/incidents': typeof AuthenticatedIncidentsRouteWithChildren
  '/_authenticated/inspections': typeof AuthenticatedInspectionsRouteWithChildren
  '/_authenticated/my-assignments': typeof AuthenticatedMyAssignmentsRoute
  '/_authenticated/my-certifications': typeof AuthenticatedMyCertificationsRoute
  '/_authenticated/my-flhas': typeof AuthenticatedMyFlhasRoute
  '/_authenticated/my-notes': typeof AuthenticatedMyNotesRoute
  '/_authenticated/my-signatures': typeof AuthenticatedMySignaturesRoute
  '/_authenticated/permits': typeof AuthenticatedPermitsRouteWithChildren
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/review': typeof AuthenticatedReviewRoute
  '/_authenticated/safety-tasks': typeof AuthenticatedSafetyTasksRoute
  '/_authenticated/subcontractors': typeof AuthenticatedSubcontractorsRouteWithChildren
  '/_authenticated/supervisor': typeof AuthenticatedSupervisorRoute
  '/_authenticated/team-certifications': typeof AuthenticatedTeamCertificationsRoute
  '/_authenticated/toolbox': typeof AuthenticatedToolboxRouteWithChildren
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/admin/app-update': typeof AuthenticatedAdminAppUpdateRoute
  '/_authenticated/admin/assets': typeof AuthenticatedAdminAssetsRoute
  '/_authenticated/admin/assignments': typeof AuthenticatedAdminAssignmentsRoute
  '/_authenticated/admin/audit-log': typeof AuthenticatedAdminAuditLogRoute
  '/_authenticated/admin/backup': typeof AuthenticatedAdminBackupRoute
  '/_authenticated/admin/catalogs': typeof AuthenticatedAdminCatalogsRoute
  '/_authenticated/admin/certifications': typeof AuthenticatedAdminCertificationsRoute
  '/_authenticated/admin/corrective-actions': typeof AuthenticatedAdminCorrectiveActionsRoute
  '/_authenticated/admin/divisions': typeof AuthenticatedAdminDivisionsRoute
  '/_authenticated/admin/documents': typeof AuthenticatedAdminDocumentsRoute
  '/_authenticated/admin/export': typeof AuthenticatedAdminExportRoute
  '/_authenticated/admin/inspections': typeof AuthenticatedAdminInspectionsRoute
  '/_authenticated/admin/invitations': typeof AuthenticatedAdminInvitationsRoute
  '/_authenticated/admin/job-titles': typeof AuthenticatedAdminJobTitlesRoute
  '/_authenticated/admin/layout': typeof AuthenticatedAdminLayoutRoute
  '/_authenticated/admin/mappings': typeof AuthenticatedAdminMappingsRoute
  '/_authenticated/admin/notes': typeof AuthenticatedAdminNotesRoute
  '/_authenticated/admin/permits': typeof AuthenticatedAdminPermitsRoute
  '/_authenticated/admin/recipients': typeof AuthenticatedAdminRecipientsRoute
  '/_authenticated/admin/signing-reports': typeof AuthenticatedAdminSigningReportsRoute
  '/_authenticated/admin/templates': typeof AuthenticatedAdminTemplatesRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/assets/$assetId': typeof AuthenticatedAssetsAssetIdRouteWithChildren
  '/_authenticated/assets/scan': typeof AuthenticatedAssetsScanRoute
  '/_authenticated/corrective-actions/$actionId': typeof AuthenticatedCorrectiveActionsActionIdRoute
  '/_authenticated/flha/$flhaId': typeof AuthenticatedFlhaFlhaIdRoute
  '/_authenticated/hazards/new': typeof AuthenticatedHazardsNewRoute
  '/_authenticated/incidents/$incidentId': typeof AuthenticatedIncidentsIncidentIdRoute
  '/_authenticated/incidents/report': typeof AuthenticatedIncidentsReportRoute
  '/_authenticated/inspections/$inspectionId': typeof AuthenticatedInspectionsInspectionIdRouteWithChildren
  '/_authenticated/inspections/new': typeof AuthenticatedInspectionsNewRoute
  '/_authenticated/permits/$permitId': typeof AuthenticatedPermitsPermitIdRoute
  '/_authenticated/permits/new': typeof AuthenticatedPermitsNewRoute
  '/_authenticated/projects/$projectId': typeof AuthenticatedProjectsProjectIdRoute
  '/_authenticated/reports/export': typeof AuthenticatedReportsExportRoute
  '/_authenticated/reports/hazards': typeof AuthenticatedReportsHazardsRoute
  '/_authenticated/reports/heatmap': typeof AuthenticatedReportsHeatmapRoute
  '/_authenticated/reports/high-risk': typeof AuthenticatedReportsHighRiskRoute
  '/_authenticated/reports/permits': typeof AuthenticatedReportsPermitsRoute
  '/_authenticated/reports/subs': typeof AuthenticatedReportsSubsRoute
  '/_authenticated/toolbox/$meetingId': typeof AuthenticatedToolboxMeetingIdRoute
  '/_authenticated/toolbox/access': typeof AuthenticatedToolboxAccessRoute
  '/_authenticated/toolbox/assignments': typeof AuthenticatedToolboxAssignmentsRoute
  '/_authenticated/toolbox/library': typeof AuthenticatedToolboxLibraryRoute
  '/_authenticated/toolbox/new': typeof AuthenticatedToolboxNewRoute
  '/_wizard/flha/new': typeof WizardFlhaNewRoute
  '/_wizard/flha/new-v2': typeof WizardFlhaNewV2Route
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/assets/': typeof AuthenticatedAssetsIndexRoute
  '/_authenticated/permits/': typeof AuthenticatedPermitsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/subcontractors/': typeof AuthenticatedSubcontractorsIndexRoute
  '/_authenticated/toolbox/': typeof AuthenticatedToolboxIndexRoute
  '/_authenticated/assets/$assetId/checkout': typeof AuthenticatedAssetsAssetIdCheckoutRoute
  '/_authenticated/inspections/$inspectionId/swipe': typeof AuthenticatedInspectionsInspectionIdSwipeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/signup'
    | '/sub-join'
    | '/admin'
    | '/approvals'
    | '/assets'
    | '/corrective-actions'
    | '/documents'
    | '/flhas'
    | '/hazards'
    | '/incidents'
    | '/inspections'
    | '/my-assignments'
    | '/my-certifications'
    | '/my-flhas'
    | '/my-notes'
    | '/my-signatures'
    | '/permits'
    | '/profile'
    | '/reports'
    | '/review'
    | '/safety-tasks'
    | '/subcontractors'
    | '/supervisor'
    | '/team-certifications'
    | '/toolbox'
    | '/admin/app-update'
    | '/admin/assets'
    | '/admin/assignments'
    | '/admin/audit-log'
    | '/admin/backup'
    | '/admin/catalogs'
    | '/admin/certifications'
    | '/admin/corrective-actions'
    | '/admin/divisions'
    | '/admin/documents'
    | '/admin/export'
    | '/admin/inspections'
    | '/admin/invitations'
    | '/admin/job-titles'
    | '/admin/layout'
    | '/admin/mappings'
    | '/admin/notes'
    | '/admin/permits'
    | '/admin/recipients'
    | '/admin/signing-reports'
    | '/admin/templates'
    | '/admin/users'
    | '/assets/$assetId'
    | '/assets/scan'
    | '/corrective-actions/$actionId'
    | '/flha/$flhaId'
    | '/hazards/new'
    | '/incidents/$incidentId'
    | '/incidents/report'
    | '/inspections/$inspectionId'
    | '/inspections/new'
    | '/permits/$permitId'
    | '/permits/new'
    | '/projects/$projectId'
    | '/reports/export'
    | '/reports/hazards'
    | '/reports/heatmap'
    | '/reports/high-risk'
    | '/reports/permits'
    | '/reports/subs'
    | '/toolbox/$meetingId'
    | '/toolbox/access'
    | '/toolbox/assignments'
    | '/toolbox/library'
    | '/toolbox/new'
    | '/flha/new'
    | '/flha/new-v2'
    | '/admin/'
    | '/assets/'
    | '/permits/'
    | '/projects/'
    | '/reports/'
    | '/subcontractors/'
    | '/toolbox/'
    | '/assets/$assetId/checkout'
    | '/inspections/$inspectionId/swipe'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/signup'
    | '/sub-join'
    | '/approvals'
    | '/corrective-actions'
    | '/documents'
    | '/flhas'
    | '/hazards'
    | '/incidents'
    | '/inspections'
    | '/my-assignments'
    | '/my-certifications'
    | '/my-flhas'
    | '/my-notes'
    | '/my-signatures'
    | '/profile'
    | '/review'
    | '/safety-tasks'
    | '/supervisor'
    | '/team-certifications'
    | '/admin/app-update'
    | '/admin/assets'
    | '/admin/assignments'
    | '/admin/audit-log'
    | '/admin/backup'
    | '/admin/catalogs'
    | '/admin/certifications'
    | '/admin/corrective-actions'
    | '/admin/divisions'
    | '/admin/documents'
    | '/admin/export'
    | '/admin/inspections'
    | '/admin/invitations'
    | '/admin/job-titles'
    | '/admin/layout'
    | '/admin/mappings'
    | '/admin/notes'
    | '/admin/permits'
    | '/admin/recipients'
    | '/admin/signing-reports'
    | '/admin/templates'
    | '/admin/users'
    | '/assets/$assetId'
    | '/assets/scan'
    | '/corrective-actions/$actionId'
    | '/flha/$flhaId'
    | '/hazards/new'
    | '/incidents/$incidentId'
    | '/incidents/report'
    | '/inspections/$inspectionId'
    | '/inspections/new'
    | '/permits/$permitId'
    | '/permits/new'
    | '/projects/$projectId'
    | '/reports/export'
    | '/reports/hazards'
    | '/reports/heatmap'
    | '/reports/high-risk'
    | '/reports/permits'
    | '/reports/subs'
    | '/toolbox/$meetingId'
    | '/toolbox/access'
    | '/toolbox/assignments'
    | '/toolbox/library'
    | '/toolbox/new'
    | '/flha/new'
    | '/flha/new-v2'
    | '/admin'
    | '/assets'
    | '/permits'
    | '/projects'
    | '/reports'
    | '/subcontractors'
    | '/toolbox'
    | '/assets/$assetId/checkout'
    | '/inspections/$inspectionId/swipe'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_wizard'
    | '/forgot-password'
    | '/invite'
    | '/login'
    | '/signup'
    | '/sub-join'
    | '/_authenticated/admin'
    | '/_authenticated/approvals'
    | '/_authenticated/assets'
    | '/_authenticated/corrective-actions'
    | '/_authenticated/documents'
    | '/_authenticated/flhas'
    | '/_authenticated/hazards'
    | '/_authenticated/incidents'
    | '/_authenticated/inspections'
    | '/_authenticated/my-assignments'
    | '/_authenticated/my-certifications'
    | '/_authenticated/my-flhas'
    | '/_authenticated/my-notes'
    | '/_authenticated/my-signatures'
    | '/_authenticated/permits'
    | '/_authenticated/profile'
    | '/_authenticated/reports'
    | '/_authenticated/review'
    | '/_authenticated/safety-tasks'
    | '/_authenticated/subcontractors'
    | '/_authenticated/supervisor'
    | '/_authenticated/team-certifications'
    | '/_authenticated/toolbox'
    | '/_authenticated/'
    | '/_authenticated/admin/app-update'
    | '/_authenticated/admin/assets'
    | '/_authenticated/admin/assignments'
    | '/_authenticated/admin/audit-log'
    | '/_authenticated/admin/backup'
    | '/_authenticated/admin/catalogs'
    | '/_authenticated/admin/certifications'
    | '/_authenticated/admin/corrective-actions'
    | '/_authenticated/admin/divisions'
    | '/_authenticated/admin/documents'
    | '/_authenticated/admin/export'
    | '/_authenticated/admin/inspections'
    | '/_authenticated/admin/invitations'
    | '/_authenticated/admin/job-titles'
    | '/_authenticated/admin/layout'
    | '/_authenticated/admin/mappings'
    | '/_authenticated/admin/notes'
    | '/_authenticated/admin/permits'
    | '/_authenticated/admin/recipients'
    | '/_authenticated/admin/signing-reports'
    | '/_authenticated/admin/templates'
    | '/_authenticated/admin/users'
    | '/_authenticated/assets/$assetId'
    | '/_authenticated/assets/scan'
    | '/_authenticated/corrective-actions/$actionId'
    | '/_authenticated/flha/$flhaId'
    | '/_authenticated/hazards/new'
    | '/_authenticated/incidents/$incidentId'
    | '/_authenticated/incidents/report'
    | '/_authenticated/inspections/$inspectionId'
    | '/_authenticated/inspections/new'
    | '/_authenticated/permits/$permitId'
    | '/_authenticated/permits/new'
    | '/_authenticated/projects/$projectId'
    | '/_authenticated/reports/export'
    | '/_authenticated/reports/hazards'
    | '/_authenticated/reports/heatmap'
    | '/_authenticated/reports/high-risk'
    | '/_authenticated/reports/permits'
    | '/_authenticated/reports/subs'
    | '/_authenticated/toolbox/$meetingId'
    | '/_authenticated/toolbox/access'
    | '/_authenticated/toolbox/assignments'
    | '/_authenticated/toolbox/library'
    | '/_authenticated/toolbox/new'
    | '/_wizard/flha/new'
    | '/_wizard/flha/new-v2'
    | '/_authenticated/admin/'
    | '/_authenticated/assets/'
    | '/_authenticated/permits/'
    | '/_authenticated/projects/'
    | '/_authenticated/reports/'
    | '/_authenticated/subcontractors/'
    | '/_authenticated/toolbox/'
    | '/_authenticated/assets/$assetId/checkout'
    | '/_authenticated/inspections/$inspectionId/swipe'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  WizardRoute: typeof WizardRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  InviteRoute: typeof InviteRoute
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  SubJoinRoute: typeof SubJoinRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sub-join': {
      id: '/sub-join'
      path: '/sub-join'
      fullPath: '/sub-join'
      preLoaderRoute: typeof SubJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite': {
      id: '/invite'
      path: '/invite'
      fullPath: '/invite'
      preLoaderRoute: typeof InviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_wizard': {
      id: '/_wizard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WizardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/toolbox': {
      id: '/_authenticated/toolbox'
      path: '/toolbox'
      fullPath: '/toolbox'
      preLoaderRoute: typeof AuthenticatedToolboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/team-certifications': {
      id: '/_authenticated/team-certifications'
      path: '/team-certifications'
      fullPath: '/team-certifications'
      preLoaderRoute: typeof AuthenticatedTeamCertificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/supervisor': {
      id: '/_authenticated/supervisor'
      path: '/supervisor'
      fullPath: '/supervisor'
      preLoaderRoute: typeof AuthenticatedSupervisorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/subcontractors': {
      id: '/_authenticated/subcontractors'
      path: '/subcontractors'
      fullPath: '/subcontractors'
      preLoaderRoute: typeof AuthenticatedSubcontractorsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/safety-tasks': {
      id: '/_authenticated/safety-tasks'
      path: '/safety-tasks'
      fullPath: '/safety-tasks'
      preLoaderRoute: typeof AuthenticatedSafetyTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/review': {
      id: '/_authenticated/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthenticatedReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits': {
      id: '/_authenticated/permits'
      path: '/permits'
      fullPath: '/permits'
      preLoaderRoute: typeof AuthenticatedPermitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-signatures': {
      id: '/_authenticated/my-signatures'
      path: '/my-signatures'
      fullPath: '/my-signatures'
      preLoaderRoute: typeof AuthenticatedMySignaturesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-notes': {
      id: '/_authenticated/my-notes'
      path: '/my-notes'
      fullPath: '/my-notes'
      preLoaderRoute: typeof AuthenticatedMyNotesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-flhas': {
      id: '/_authenticated/my-flhas'
      path: '/my-flhas'
      fullPath: '/my-flhas'
      preLoaderRoute: typeof AuthenticatedMyFlhasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-certifications': {
      id: '/_authenticated/my-certifications'
      path: '/my-certifications'
      fullPath: '/my-certifications'
      preLoaderRoute: typeof AuthenticatedMyCertificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-assignments': {
      id: '/_authenticated/my-assignments'
      path: '/my-assignments'
      fullPath: '/my-assignments'
      preLoaderRoute: typeof AuthenticatedMyAssignmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inspections': {
      id: '/_authenticated/inspections'
      path: '/inspections'
      fullPath: '/inspections'
      preLoaderRoute: typeof AuthenticatedInspectionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incidents': {
      id: '/_authenticated/incidents'
      path: '/incidents'
      fullPath: '/incidents'
      preLoaderRoute: typeof AuthenticatedIncidentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hazards': {
      id: '/_authenticated/hazards'
      path: '/hazards'
      fullPath: '/hazards'
      preLoaderRoute: typeof AuthenticatedHazardsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/flhas': {
      id: '/_authenticated/flhas'
      path: '/flhas'
      fullPath: '/flhas'
      preLoaderRoute: typeof AuthenticatedFlhasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/corrective-actions': {
      id: '/_authenticated/corrective-actions'
      path: '/corrective-actions'
      fullPath: '/corrective-actions'
      preLoaderRoute: typeof AuthenticatedCorrectiveActionsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/approvals': {
      id: '/_authenticated/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthenticatedApprovalsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/toolbox/': {
      id: '/_authenticated/toolbox/'
      path: '/'
      fullPath: '/toolbox/'
      preLoaderRoute: typeof AuthenticatedToolboxIndexRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/subcontractors/': {
      id: '/_authenticated/subcontractors/'
      path: '/'
      fullPath: '/subcontractors/'
      preLoaderRoute: typeof AuthenticatedSubcontractorsIndexRouteImport
      parentRoute: typeof AuthenticatedSubcontractorsRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/': {
      id: '/_authenticated/permits/'
      path: '/'
      fullPath: '/permits/'
      preLoaderRoute: typeof AuthenticatedPermitsIndexRouteImport
      parentRoute: typeof AuthenticatedPermitsRoute
    }
    '/_authenticated/assets/': {
      id: '/_authenticated/assets/'
      path: '/'
      fullPath: '/assets/'
      preLoaderRoute: typeof AuthenticatedAssetsIndexRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_wizard/flha/new-v2': {
      id: '/_wizard/flha/new-v2'
      path: '/flha/new-v2'
      fullPath: '/flha/new-v2'
      preLoaderRoute: typeof WizardFlhaNewV2RouteImport
      parentRoute: typeof WizardRoute
    }
    '/_wizard/flha/new': {
      id: '/_wizard/flha/new'
      path: '/flha/new'
      fullPath: '/flha/new'
      preLoaderRoute: typeof WizardFlhaNewRouteImport
      parentRoute: typeof WizardRoute
    }
    '/_authenticated/toolbox/new': {
      id: '/_authenticated/toolbox/new'
      path: '/new'
      fullPath: '/toolbox/new'
      preLoaderRoute: typeof AuthenticatedToolboxNewRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/toolbox/library': {
      id: '/_authenticated/toolbox/library'
      path: '/library'
      fullPath: '/toolbox/library'
      preLoaderRoute: typeof AuthenticatedToolboxLibraryRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/toolbox/assignments': {
      id: '/_authenticated/toolbox/assignments'
      path: '/assignments'
      fullPath: '/toolbox/assignments'
      preLoaderRoute: typeof AuthenticatedToolboxAssignmentsRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/toolbox/access': {
      id: '/_authenticated/toolbox/access'
      path: '/access'
      fullPath: '/toolbox/access'
      preLoaderRoute: typeof AuthenticatedToolboxAccessRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/toolbox/$meetingId': {
      id: '/_authenticated/toolbox/$meetingId'
      path: '/$meetingId'
      fullPath: '/toolbox/$meetingId'
      preLoaderRoute: typeof AuthenticatedToolboxMeetingIdRouteImport
      parentRoute: typeof AuthenticatedToolboxRoute
    }
    '/_authenticated/reports/subs': {
      id: '/_authenticated/reports/subs'
      path: '/subs'
      fullPath: '/reports/subs'
      preLoaderRoute: typeof AuthenticatedReportsSubsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/permits': {
      id: '/_authenticated/reports/permits'
      path: '/permits'
      fullPath: '/reports/permits'
      preLoaderRoute: typeof AuthenticatedReportsPermitsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/high-risk': {
      id: '/_authenticated/reports/high-risk'
      path: '/high-risk'
      fullPath: '/reports/high-risk'
      preLoaderRoute: typeof AuthenticatedReportsHighRiskRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/heatmap': {
      id: '/_authenticated/reports/heatmap'
      path: '/heatmap'
      fullPath: '/reports/heatmap'
      preLoaderRoute: typeof AuthenticatedReportsHeatmapRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/hazards': {
      id: '/_authenticated/reports/hazards'
      path: '/hazards'
      fullPath: '/reports/hazards'
      preLoaderRoute: typeof AuthenticatedReportsHazardsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/export': {
      id: '/_authenticated/reports/export'
      path: '/export'
      fullPath: '/reports/export'
      preLoaderRoute: typeof AuthenticatedReportsExportRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/projects/$projectId': {
      id: '/_authenticated/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/permits/new': {
      id: '/_authenticated/permits/new'
      path: '/new'
      fullPath: '/permits/new'
      preLoaderRoute: typeof AuthenticatedPermitsNewRouteImport
      parentRoute: typeof AuthenticatedPermitsRoute
    }
    '/_authenticated/permits/$permitId': {
      id: '/_authenticated/permits/$permitId'
      path: '/$permitId'
      fullPath: '/permits/$permitId'
      preLoaderRoute: typeof AuthenticatedPermitsPermitIdRouteImport
      parentRoute: typeof AuthenticatedPermitsRoute
    }
    '/_authenticated/inspections/new': {
      id: '/_authenticated/inspections/new'
      path: '/new'
      fullPath: '/inspections/new'
      preLoaderRoute: typeof AuthenticatedInspectionsNewRouteImport
      parentRoute: typeof AuthenticatedInspectionsRoute
    }
    '/_authenticated/inspections/$inspectionId': {
      id: '/_authenticated/inspections/$inspectionId'
      path: '/$inspectionId'
      fullPath: '/inspections/$inspectionId'
      preLoaderRoute: typeof AuthenticatedInspectionsInspectionIdRouteImport
      parentRoute: typeof AuthenticatedInspectionsRoute
    }
    '/_authenticated/incidents/report': {
      id: '/_authenticated/incidents/report'
      path: '/report'
      fullPath: '/incidents/report'
      preLoaderRoute: typeof AuthenticatedIncidentsReportRouteImport
      parentRoute: typeof AuthenticatedIncidentsRoute
    }
    '/_authenticated/incidents/$incidentId': {
      id: '/_authenticated/incidents/$incidentId'
      path: '/$incidentId'
      fullPath: '/incidents/$incidentId'
      preLoaderRoute: typeof AuthenticatedIncidentsIncidentIdRouteImport
      parentRoute: typeof AuthenticatedIncidentsRoute
    }
    '/_authenticated/hazards/new': {
      id: '/_authenticated/hazards/new'
      path: '/new'
      fullPath: '/hazards/new'
      preLoaderRoute: typeof AuthenticatedHazardsNewRouteImport
      parentRoute: typeof AuthenticatedHazardsRoute
    }
    '/_authenticated/flha/$flhaId': {
      id: '/_authenticated/flha/$flhaId'
      path: '/flha/$flhaId'
      fullPath: '/flha/$flhaId'
      preLoaderRoute: typeof AuthenticatedFlhaFlhaIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/corrective-actions/$actionId': {
      id: '/_authenticated/corrective-actions/$actionId'
      path: '/$actionId'
      fullPath: '/corrective-actions/$actionId'
      preLoaderRoute: typeof AuthenticatedCorrectiveActionsActionIdRouteImport
      parentRoute: typeof AuthenticatedCorrectiveActionsRoute
    }
    '/_authenticated/assets/scan': {
      id: '/_authenticated/assets/scan'
      path: '/scan'
      fullPath: '/assets/scan'
      preLoaderRoute: typeof AuthenticatedAssetsScanRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/assets/$assetId': {
      id: '/_authenticated/assets/$assetId'
      path: '/$assetId'
      fullPath: '/assets/$assetId'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdRouteImport
      parentRoute: typeof AuthenticatedAssetsRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/templates': {
      id: '/_authenticated/admin/templates'
      path: '/templates'
      fullPath: '/admin/templates'
      preLoaderRoute: typeof AuthenticatedAdminTemplatesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/signing-reports': {
      id: '/_authenticated/admin/signing-reports'
      path: '/signing-reports'
      fullPath: '/admin/signing-reports'
      preLoaderRoute: typeof AuthenticatedAdminSigningReportsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/recipients': {
      id: '/_authenticated/admin/recipients'
      path: '/recipients'
      fullPath: '/admin/recipients'
      preLoaderRoute: typeof AuthenticatedAdminRecipientsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/permits': {
      id: '/_authenticated/admin/permits'
      path: '/permits'
      fullPath: '/admin/permits'
      preLoaderRoute: typeof AuthenticatedAdminPermitsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/notes': {
      id: '/_authenticated/admin/notes'
      path: '/notes'
      fullPath: '/admin/notes'
      preLoaderRoute: typeof AuthenticatedAdminNotesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/mappings': {
      id: '/_authenticated/admin/mappings'
      path: '/mappings'
      fullPath: '/admin/mappings'
      preLoaderRoute: typeof AuthenticatedAdminMappingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/layout': {
      id: '/_authenticated/admin/layout'
      path: '/layout'
      fullPath: '/admin/layout'
      preLoaderRoute: typeof AuthenticatedAdminLayoutRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/job-titles': {
      id: '/_authenticated/admin/job-titles'
      path: '/job-titles'
      fullPath: '/admin/job-titles'
      preLoaderRoute: typeof AuthenticatedAdminJobTitlesRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/invitations': {
      id: '/_authenticated/admin/invitations'
      path: '/invitations'
      fullPath: '/admin/invitations'
      preLoaderRoute: typeof AuthenticatedAdminInvitationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/inspections': {
      id: '/_authenticated/admin/inspections'
      path: '/inspections'
      fullPath: '/admin/inspections'
      preLoaderRoute: typeof AuthenticatedAdminInspectionsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/export': {
      id: '/_authenticated/admin/export'
      path: '/export'
      fullPath: '/admin/export'
      preLoaderRoute: typeof AuthenticatedAdminExportRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/documents': {
      id: '/_authenticated/admin/documents'
      path: '/documents'
      fullPath: '/admin/documents'
      preLoaderRoute: typeof AuthenticatedAdminDocumentsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/divisions': {
      id: '/_authenticated/admin/divisions'
      path: '/divisions'
      fullPath: '/admin/divisions'
      preLoaderRoute: typeof AuthenticatedAdminDivisionsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/corrective-actions': {
      id: '/_authenticated/admin/corrective-actions'
      path: '/corrective-actions'
      fullPath: '/admin/corrective-actions'
      preLoaderRoute: typeof AuthenticatedAdminCorrectiveActionsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/certifications': {
      id: '/_authenticated/admin/certifications'
      path: '/certifications'
      fullPath: '/admin/certifications'
      preLoaderRoute: typeof AuthenticatedAdminCertificationsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/catalogs': {
      id: '/_authenticated/admin/catalogs'
      path: '/catalogs'
      fullPath: '/admin/catalogs'
      preLoaderRoute: typeof AuthenticatedAdminCatalogsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/backup': {
      id: '/_authenticated/admin/backup'
      path: '/backup'
      fullPath: '/admin/backup'
      preLoaderRoute: typeof AuthenticatedAdminBackupRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/audit-log': {
      id: '/_authenticated/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AuthenticatedAdminAuditLogRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/assignments': {
      id: '/_authenticated/admin/assignments'
      path: '/assignments'
      fullPath: '/admin/assignments'
      preLoaderRoute: typeof AuthenticatedAdminAssignmentsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/assets': {
      id: '/_authenticated/admin/assets'
      path: '/assets'
      fullPath: '/admin/assets'
      preLoaderRoute: typeof AuthenticatedAdminAssetsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/app-update': {
      id: '/_authenticated/admin/app-update'
      path: '/app-update'
      fullPath: '/admin/app-update'
      preLoaderRoute: typeof AuthenticatedAdminAppUpdateRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/inspections/$inspectionId/swipe': {
      id: '/_authenticated/inspections/$inspectionId/swipe'
      path: '/swipe'
      fullPath: '/inspections/$inspectionId/swipe'
      preLoaderRoute: typeof AuthenticatedInspectionsInspectionIdSwipeRouteImport
      parentRoute: typeof AuthenticatedInspectionsInspectionIdRoute
    }
    '/_authenticated/assets/$assetId/checkout': {
      id: '/_authenticated/assets/$assetId/checkout'
      path: '/checkout'
      fullPath: '/assets/$assetId/checkout'
      preLoaderRoute: typeof AuthenticatedAssetsAssetIdCheckoutRouteImport
      parentRoute: typeof AuthenticatedAssetsAssetIdRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAppUpdateRoute: typeof AuthenticatedAdminAppUpdateRoute
  AuthenticatedAdminAssetsRoute: typeof AuthenticatedAdminAssetsRoute
  AuthenticatedAdminAssignmentsRoute: typeof AuthenticatedAdminAssignmentsRoute
  AuthenticatedAdminAuditLogRoute: typeof AuthenticatedAdminAuditLogRoute
  AuthenticatedAdminBackupRoute: typeof AuthenticatedAdminBackupRoute
  AuthenticatedAdminCatalogsRoute: typeof AuthenticatedAdminCatalogsRoute
  AuthenticatedAdminCertificationsRoute: typeof AuthenticatedAdminCertificationsRoute
  AuthenticatedAdminCorrectiveActionsRoute: typeof AuthenticatedAdminCorrectiveActionsRoute
  AuthenticatedAdminDivisionsRoute: typeof AuthenticatedAdminDivisionsRoute
  AuthenticatedAdminDocumentsRoute: typeof AuthenticatedAdminDocumentsRoute
  AuthenticatedAdminExportRoute: typeof AuthenticatedAdminExportRoute
  AuthenticatedAdminInspectionsRoute: typeof AuthenticatedAdminInspectionsRoute
  AuthenticatedAdminInvitationsRoute: typeof AuthenticatedAdminInvitationsRoute
  AuthenticatedAdminJobTitlesRoute: typeof AuthenticatedAdminJobTitlesRoute
  AuthenticatedAdminLayoutRoute: typeof AuthenticatedAdminLayoutRoute
  AuthenticatedAdminMappingsRoute: typeof AuthenticatedAdminMappingsRoute
  AuthenticatedAdminNotesRoute: typeof AuthenticatedAdminNotesRoute
  AuthenticatedAdminPermitsRoute: typeof AuthenticatedAdminPermitsRoute
  AuthenticatedAdminRecipientsRoute: typeof AuthenticatedAdminRecipientsRoute
  AuthenticatedAdminSigningReportsRoute: typeof AuthenticatedAdminSigningReportsRoute
  AuthenticatedAdminTemplatesRoute: typeof AuthenticatedAdminTemplatesRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAppUpdateRoute: AuthenticatedAdminAppUpdateRoute,
  AuthenticatedAdminAssetsRoute: AuthenticatedAdminAssetsRoute,
  AuthenticatedAdminAssignmentsRoute: AuthenticatedAdminAssignmentsRoute,
  AuthenticatedAdminAuditLogRoute: AuthenticatedAdminAuditLogRoute,
  AuthenticatedAdminBackupRoute: AuthenticatedAdminBackupRoute,
  AuthenticatedAdminCatalogsRoute: AuthenticatedAdminCatalogsRoute,
  AuthenticatedAdminCertificationsRoute: AuthenticatedAdminCertificationsRoute,
  AuthenticatedAdminCorrectiveActionsRoute:
    AuthenticatedAdminCorrectiveActionsRoute,
  AuthenticatedAdminDivisionsRoute: AuthenticatedAdminDivisionsRoute,
  AuthenticatedAdminDocumentsRoute: AuthenticatedAdminDocumentsRoute,
  AuthenticatedAdminExportRoute: AuthenticatedAdminExportRoute,
  AuthenticatedAdminInspectionsRoute: AuthenticatedAdminInspectionsRoute,
  AuthenticatedAdminInvitationsRoute: AuthenticatedAdminInvitationsRoute,
  AuthenticatedAdminJobTitlesRoute: AuthenticatedAdminJobTitlesRoute,
  AuthenticatedAdminLayoutRoute: AuthenticatedAdminLayoutRoute,
  AuthenticatedAdminMappingsRoute: AuthenticatedAdminMappingsRoute,
  AuthenticatedAdminNotesRoute: AuthenticatedAdminNotesRoute,
  AuthenticatedAdminPermitsRoute: AuthenticatedAdminPermitsRoute,
  AuthenticatedAdminRecipientsRoute: AuthenticatedAdminRecipientsRoute,
  AuthenticatedAdminSigningReportsRoute: AuthenticatedAdminSigningReportsRoute,
  AuthenticatedAdminTemplatesRoute: AuthenticatedAdminTemplatesRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedAssetsAssetIdRouteChildren {
  AuthenticatedAssetsAssetIdCheckoutRoute: typeof AuthenticatedAssetsAssetIdCheckoutRoute
}

const AuthenticatedAssetsAssetIdRouteChildren: AuthenticatedAssetsAssetIdRouteChildren =
  {
    AuthenticatedAssetsAssetIdCheckoutRoute:
      AuthenticatedAssetsAssetIdCheckoutRoute,
  }

const AuthenticatedAssetsAssetIdRouteWithChildren =
  AuthenticatedAssetsAssetIdRoute._addFileChildren(
    AuthenticatedAssetsAssetIdRouteChildren,
  )

interface AuthenticatedAssetsRouteChildren {
  AuthenticatedAssetsAssetIdRoute: typeof AuthenticatedAssetsAssetIdRouteWithChildren
  AuthenticatedAssetsScanRoute: typeof AuthenticatedAssetsScanRoute
  AuthenticatedAssetsIndexRoute: typeof AuthenticatedAssetsIndexRoute
}

const AuthenticatedAssetsRouteChildren: AuthenticatedAssetsRouteChildren = {
  AuthenticatedAssetsAssetIdRoute: AuthenticatedAssetsAssetIdRouteWithChildren,
  AuthenticatedAssetsScanRoute: AuthenticatedAssetsScanRoute,
  AuthenticatedAssetsIndexRoute: AuthenticatedAssetsIndexRoute,
}

const AuthenticatedAssetsRouteWithChildren =
  AuthenticatedAssetsRoute._addFileChildren(AuthenticatedAssetsRouteChildren)

interface AuthenticatedCorrectiveActionsRouteChildren {
  AuthenticatedCorrectiveActionsActionIdRoute: typeof AuthenticatedCorrectiveActionsActionIdRoute
}

const AuthenticatedCorrectiveActionsRouteChildren: AuthenticatedCorrectiveActionsRouteChildren =
  {
    AuthenticatedCorrectiveActionsActionIdRoute:
      AuthenticatedCorrectiveActionsActionIdRoute,
  }

const AuthenticatedCorrectiveActionsRouteWithChildren =
  AuthenticatedCorrectiveActionsRoute._addFileChildren(
    AuthenticatedCorrectiveActionsRouteChildren,
  )

interface AuthenticatedHazardsRouteChildren {
  AuthenticatedHazardsNewRoute: typeof AuthenticatedHazardsNewRoute
}

const AuthenticatedHazardsRouteChildren: AuthenticatedHazardsRouteChildren = {
  AuthenticatedHazardsNewRoute: AuthenticatedHazardsNewRoute,
}

const AuthenticatedHazardsRouteWithChildren =
  AuthenticatedHazardsRoute._addFileChildren(AuthenticatedHazardsRouteChildren)

interface AuthenticatedIncidentsRouteChildren {
  AuthenticatedIncidentsIncidentIdRoute: typeof AuthenticatedIncidentsIncidentIdRoute
  AuthenticatedIncidentsReportRoute: typeof AuthenticatedIncidentsReportRoute
}

const AuthenticatedIncidentsRouteChildren: AuthenticatedIncidentsRouteChildren =
  {
    AuthenticatedIncidentsIncidentIdRoute:
      AuthenticatedIncidentsIncidentIdRoute,
    AuthenticatedIncidentsReportRoute: AuthenticatedIncidentsReportRoute,
  }

const AuthenticatedIncidentsRouteWithChildren =
  AuthenticatedIncidentsRoute._addFileChildren(
    AuthenticatedIncidentsRouteChildren,
  )

interface AuthenticatedInspectionsInspectionIdRouteChildren {
  AuthenticatedInspectionsInspectionIdSwipeRoute: typeof AuthenticatedInspectionsInspectionIdSwipeRoute
}

const AuthenticatedInspectionsInspectionIdRouteChildren: AuthenticatedInspectionsInspectionIdRouteChildren =
  {
    AuthenticatedInspectionsInspectionIdSwipeRoute:
      AuthenticatedInspectionsInspectionIdSwipeRoute,
  }

const AuthenticatedInspectionsInspectionIdRouteWithChildren =
  AuthenticatedInspectionsInspectionIdRoute._addFileChildren(
    AuthenticatedInspectionsInspectionIdRouteChildren,
  )

interface AuthenticatedInspectionsRouteChildren {
  AuthenticatedInspectionsInspectionIdRoute: typeof AuthenticatedInspectionsInspectionIdRouteWithChildren
  AuthenticatedInspectionsNewRoute: typeof AuthenticatedInspectionsNewRoute
}

const AuthenticatedInspectionsRouteChildren: AuthenticatedInspectionsRouteChildren =
  {
    AuthenticatedInspectionsInspectionIdRoute:
      AuthenticatedInspectionsInspectionIdRouteWithChildren,
    AuthenticatedInspectionsNewRoute: AuthenticatedInspectionsNewRoute,
  }

const AuthenticatedInspectionsRouteWithChildren =
  AuthenticatedInspectionsRoute._addFileChildren(
    AuthenticatedInspectionsRouteChildren,
  )

interface AuthenticatedPermitsRouteChildren {
  AuthenticatedPermitsPermitIdRoute: typeof AuthenticatedPermitsPermitIdRoute
  AuthenticatedPermitsNewRoute: typeof AuthenticatedPermitsNewRoute
  AuthenticatedPermitsIndexRoute: typeof AuthenticatedPermitsIndexRoute
}

const AuthenticatedPermitsRouteChildren: AuthenticatedPermitsRouteChildren = {
  AuthenticatedPermitsPermitIdRoute: AuthenticatedPermitsPermitIdRoute,
  AuthenticatedPermitsNewRoute: AuthenticatedPermitsNewRoute,
  AuthenticatedPermitsIndexRoute: AuthenticatedPermitsIndexRoute,
}

const AuthenticatedPermitsRouteWithChildren =
  AuthenticatedPermitsRoute._addFileChildren(AuthenticatedPermitsRouteChildren)

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsExportRoute: typeof AuthenticatedReportsExportRoute
  AuthenticatedReportsHazardsRoute: typeof AuthenticatedReportsHazardsRoute
  AuthenticatedReportsHeatmapRoute: typeof AuthenticatedReportsHeatmapRoute
  AuthenticatedReportsHighRiskRoute: typeof AuthenticatedReportsHighRiskRoute
  AuthenticatedReportsPermitsRoute: typeof AuthenticatedReportsPermitsRoute
  AuthenticatedReportsSubsRoute: typeof AuthenticatedReportsSubsRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsExportRoute: AuthenticatedReportsExportRoute,
  AuthenticatedReportsHazardsRoute: AuthenticatedReportsHazardsRoute,
  AuthenticatedReportsHeatmapRoute: AuthenticatedReportsHeatmapRoute,
  AuthenticatedReportsHighRiskRoute: AuthenticatedReportsHighRiskRoute,
  AuthenticatedReportsPermitsRoute: AuthenticatedReportsPermitsRoute,
  AuthenticatedReportsSubsRoute: AuthenticatedReportsSubsRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedSubcontractorsRouteChildren {
  AuthenticatedSubcontractorsIndexRoute: typeof AuthenticatedSubcontractorsIndexRoute
}

const AuthenticatedSubcontractorsRouteChildren: AuthenticatedSubcontractorsRouteChildren =
  {
    AuthenticatedSubcontractorsIndexRoute:
      AuthenticatedSubcontractorsIndexRoute,
  }

const AuthenticatedSubcontractorsRouteWithChildren =
  AuthenticatedSubcontractorsRoute._addFileChildren(
    AuthenticatedSubcontractorsRouteChildren,
  )

interface AuthenticatedToolboxRouteChildren {
  AuthenticatedToolboxMeetingIdRoute: typeof AuthenticatedToolboxMeetingIdRoute
  AuthenticatedToolboxAccessRoute: typeof AuthenticatedToolboxAccessRoute
  AuthenticatedToolboxAssignmentsRoute: typeof AuthenticatedToolboxAssignmentsRoute
  AuthenticatedToolboxLibraryRoute: typeof AuthenticatedToolboxLibraryRoute
  AuthenticatedToolboxNewRoute: typeof AuthenticatedToolboxNewRoute
  AuthenticatedToolboxIndexRoute: typeof AuthenticatedToolboxIndexRoute
}

const AuthenticatedToolboxRouteChildren: AuthenticatedToolboxRouteChildren = {
  AuthenticatedToolboxMeetingIdRoute: AuthenticatedToolboxMeetingIdRoute,
  AuthenticatedToolboxAccessRoute: AuthenticatedToolboxAccessRoute,
  AuthenticatedToolboxAssignmentsRoute: AuthenticatedToolboxAssignmentsRoute,
  AuthenticatedToolboxLibraryRoute: AuthenticatedToolboxLibraryRoute,
  AuthenticatedToolboxNewRoute: AuthenticatedToolboxNewRoute,
  AuthenticatedToolboxIndexRoute: AuthenticatedToolboxIndexRoute,
}

const AuthenticatedToolboxRouteWithChildren =
  AuthenticatedToolboxRoute._addFileChildren(AuthenticatedToolboxRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedApprovalsRoute: typeof AuthenticatedApprovalsRoute
  AuthenticatedAssetsRoute: typeof AuthenticatedAssetsRouteWithChildren
  AuthenticatedCorrectiveActionsRoute: typeof AuthenticatedCorrectiveActionsRouteWithChildren
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRoute
  AuthenticatedFlhasRoute: typeof AuthenticatedFlhasRoute
  AuthenticatedHazardsRoute: typeof AuthenticatedHazardsRouteWithChildren
  AuthenticatedIncidentsRoute: typeof AuthenticatedIncidentsRouteWithChildren
  AuthenticatedInspectionsRoute: typeof AuthenticatedInspectionsRouteWithChildren
  AuthenticatedMyAssignmentsRoute: typeof AuthenticatedMyAssignmentsRoute
  AuthenticatedMyCertificationsRoute: typeof AuthenticatedMyCertificationsRoute
  AuthenticatedMyFlhasRoute: typeof AuthenticatedMyFlhasRoute
  AuthenticatedMyNotesRoute: typeof AuthenticatedMyNotesRoute
  AuthenticatedMySignaturesRoute: typeof AuthenticatedMySignaturesRoute
  AuthenticatedPermitsRoute: typeof AuthenticatedPermitsRouteWithChildren
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedReviewRoute: typeof AuthenticatedReviewRoute
  AuthenticatedSafetyTasksRoute: typeof AuthenticatedSafetyTasksRoute
  AuthenticatedSubcontractorsRoute: typeof AuthenticatedSubcontractorsRouteWithChildren
  AuthenticatedSupervisorRoute: typeof AuthenticatedSupervisorRoute
  AuthenticatedTeamCertificationsRoute: typeof AuthenticatedTeamCertificationsRoute
  AuthenticatedToolboxRoute: typeof AuthenticatedToolboxRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedFlhaFlhaIdRoute: typeof AuthenticatedFlhaFlhaIdRoute
  AuthenticatedProjectsProjectIdRoute: typeof AuthenticatedProjectsProjectIdRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedApprovalsRoute: AuthenticatedApprovalsRoute,
  AuthenticatedAssetsRoute: AuthenticatedAssetsRouteWithChildren,
  AuthenticatedCorrectiveActionsRoute:
    AuthenticatedCorrectiveActionsRouteWithChildren,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRoute,
  AuthenticatedFlhasRoute: AuthenticatedFlhasRoute,
  AuthenticatedHazardsRoute: AuthenticatedHazardsRouteWithChildren,
  AuthenticatedIncidentsRoute: AuthenticatedIncidentsRouteWithChildren,
  AuthenticatedInspectionsRoute: AuthenticatedInspectionsRouteWithChildren,
  AuthenticatedMyAssignmentsRoute: AuthenticatedMyAssignmentsRoute,
  AuthenticatedMyCertificationsRoute: AuthenticatedMyCertificationsRoute,
  AuthenticatedMyFlhasRoute: AuthenticatedMyFlhasRoute,
  AuthenticatedMyNotesRoute: AuthenticatedMyNotesRoute,
  AuthenticatedMySignaturesRoute: AuthenticatedMySignaturesRoute,
  AuthenticatedPermitsRoute: AuthenticatedPermitsRouteWithChildren,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedReviewRoute: AuthenticatedReviewRoute,
  AuthenticatedSafetyTasksRoute: AuthenticatedSafetyTasksRoute,
  AuthenticatedSubcontractorsRoute:
    AuthenticatedSubcontractorsRouteWithChildren,
  AuthenticatedSupervisorRoute: AuthenticatedSupervisorRoute,
  AuthenticatedTeamCertificationsRoute: AuthenticatedTeamCertificationsRoute,
  AuthenticatedToolboxRoute: AuthenticatedToolboxRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedFlhaFlhaIdRoute: AuthenticatedFlhaFlhaIdRoute,
  AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface WizardRouteChildren {
  WizardFlhaNewRoute: typeof WizardFlhaNewRoute
  WizardFlhaNewV2Route: typeof WizardFlhaNewV2Route
}

const WizardRouteChildren: WizardRouteChildren = {
  WizardFlhaNewRoute: WizardFlhaNewRoute,
  WizardFlhaNewV2Route: WizardFlhaNewV2Route,
}

const WizardRouteWithChildren =
  WizardRoute._addFileChildren(WizardRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  WizardRoute: WizardRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InviteRoute: InviteRoute,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  SubJoinRoute: SubJoinRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
